export const TIPS = [
  'Najbolje je vidjeti se uživo s oglašivačem. Nemojte plaćati za proizvod koji niste vidjeli.',
  'Ako oglas izgleda predobro da bi bio istinit, vjerojatno nije.',
  'Oprezno s oglašivačima koji vas traže sliku osobne iskaznice. Vjerojatno se radi o prevarantima.',
  'Budite posebno oprezni sa sumnjivim e-mail adresama koje imaju brojeve i slova bez ikakvog značenja.',
  'Ako vidite oglase koji izgledaju kao da su prevedeni preko Google prevoditelja, vjerojatno je riječ o prijevari.',
  'Ne nosite velike sume novca kada se nalazite s oglašivačem. Poželjno je i da ne idete sami.',
  'Ukoliko vas oglašivač traži da mu za najam stana unaprijed uplatite novac putem Airbnb-a ili sličnog servisa, vjerojatno je riječ o prijevari.',
];



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/constants.ts